
import { ProjectType, Stage, ExpenseCategory, Project } from './types';

// Configurações de Negócio Centralizadas
export const APP_CONFIG = {
  TRIAL_PERIOD_DAYS: 30,
  PHOTO_TOKEN_EXPIRATION_DAYS: 7,
  MAX_FREE_PHOTOS_PER_MONTH: 1,
  MAX_FREE_PROJECTS: 1,
  MAX_PREMIUM_PROJECTS: 1,
  MAX_PRO_PROJECTS: 5,
};

export const COLORS = {
  primary: '#2DCC95',
  secondary: '#03624C',
  neutral: '#F1F7F6',
  text: '#010F1A',
  background: '#010F1A'
};

export const STRIPE_PLANS = {
  premium: {
    monthly: 'price_1SlscZC6C0LvwAHlecfDGlnv', 
    yearly: 'price_1SlschC6C0LvwAHlrJGw8TDX',  
    price: { monthly: 29.90, yearly: 299.00 },
    label: 'Premium', 
    description: 'Para quem precisa organizar uma obra.',
    features: [
      'Controle de gastos ilimitado',
      'Diário de fotos (Data e Local)',
      'Acesso para 1 colaborador',
      'Orçamento Geral da Obra',
      'Relatório PDF (1 por mês)',
      'Comparativo Orçado x Realizado'
    ]
  },
  pro: {
    monthly: 'price_1SlsZdC6C0LvwAHlsNTV5zMB', 
    yearly: 'price_1Slsa3C6C0LvwAHlXu1hd97R',  
    price: { monthly: 59.90, yearly: 599.00 }, 
    label: 'PRO+',
    description: 'Potência máxima para profissionais.',
    features: [
      'Até 5 Obras simultâneas',
      'Orçamento Detalhado por Etapas',
      'Link para Prestadores enviarem fotos',
      'Colaboradores Ilimitados',
      'Relatórios PDF Ilimitados',
      'Gestão de múltiplos orçamentos'
    ]
  }
};

export const CONSTRUCTION_STAGES: Stage[] = [
  { id: '1', name: 'Fundação', expectedBudget: 0, iconName: 'HardHat' },
  { id: '2', name: 'Alvenaria', expectedBudget: 0, iconName: 'BrickWall' },
  { id: '3', name: 'Telhado', expectedBudget: 0, iconName: 'Home' },
  { id: '4', name: 'Elétrica/Hidráulica', expectedBudget: 0, iconName: 'Zap' },
  { id: '5', name: 'Acabamento', expectedBudget: 0, iconName: 'Paintbrush' },
  { id: '6', name: 'Paisagismo', expectedBudget: 0, iconName: 'Trees' },
];

export const RENOVATION_STAGES: Stage[] = [
  { id: 'r1', name: 'Projetos', expectedBudget: 0, iconName: 'FileText' },
  { id: 'r2', name: 'Preparação', expectedBudget: 0, iconName: 'Hammer' },
  { id: 'r3', name: 'Elétrica e Hidráulica', expectedBudget: 0, iconName: 'Zap' },
  { id: 'r4', name: 'Alvenaria', expectedBudget: 0, iconName: 'BrickWall' },
  { id: 'r5', name: 'Acabamentos', expectedBudget: 0, iconName: 'Paintbrush' },
  { id: 'r6', name: 'Instalações Finais', expectedBudget: 0, iconName: 'CheckCircle' },
];

export const EMPTY_PROJECT: Project = {
  id: '',
  name: '',
  ownerId: '',
  collaborators: [],
  type: ProjectType.CONSTRUCTION,
  areaSize: 0,
  initialBudget: 0,
  budgetMode: 'general',
  startDate: new Date().toISOString().split('T')[0],
  stages: CONSTRUCTION_STAGES,
  expenses: [],
  photos: [],
  logoUrl: undefined
};
